import { motion } from "framer-motion";

const LOGO_URL = "https://static.prod-images.emergentagent.com/jobs/39ea1474-f32c-4a67-9204-d1559fcaa394/images/7cf3d4e337ee066eb9381e4d612ddfc95c611b19e8041962c7b8f8fb48b67328.png";

export const Logo = ({ size = 40, withText = true, className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="app-logo">
      <motion.img
        src={LOGO_URL}
        alt="PediaCare"
        style={{ width: size, height: size }}
        className="object-contain drop-shadow-sm"
        initial={{ scale: 0.8, rotate: -8, opacity: 0 }}
        animate={{ scale: 1, rotate: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 200, damping: 14 }}
      />
      {withText && (
        <div className="leading-none">
          <span className="font-outfit font-extrabold text-xl text-brand-ink tracking-tight">
            Clin<span className="text-brand-terracotta">Ped</span><sup className="text-[0.5em] font-bold align-super ml-0.5">™</sup>
          </span>
          <p className="font-nunito text-[9px] text-brand-ink/40 font-medium tracking-wide mt-0.5">
            Expediente Clínico Inteligente
          </p>
        </div>
      )}
    </div>
  );
};

export { LOGO_URL };
